import React, { createContext, useRef, useState } from 'react';

interface RefsContextType {
    tooltip1: React.RefObject<any>;
    tooltip2: React.RefObject<any>;
    tooltip3: React.RefObject<any>;
    showOnboard: boolean;
    setShowOnboard: Function;
}

export const RefsContext = createContext<RefsContextType>({
    tooltip1: { current: null },
    tooltip2: { current: null },
    tooltip3: { current: null },
    showOnboard: false,
    setShowOnboard: () => {}
});

export const RefsProvider: React.FC = ({ children }) => {
    const tooltip1 = useRef();
    const tooltip2 = useRef();
    const tooltip3 = useRef();
    const [ showOnboard, setShowOnboard ] = useState<boolean>(false);

    return (
        <RefsContext.Provider value={{ tooltip1, tooltip2, tooltip3, showOnboard, setShowOnboard }}>
            {children}
        </RefsContext.Provider>
    );
};